import React from 'react'
import {
  change as changeFieldValue, reduxForm,
} from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { adicionarFormasPagamento } from '../../actions/viagem/adicionarFormasPagamento';
import FormCadastrarFormaPagamento from './FormCadastrarFormaPagamento';
import calcularDescontoUsuario from '../../actions/desconto/calcularDescontoUsuario';
import selecionarDescontoUsuario from '../../actions/desconto/selecionarValorDescontoCalculado';
import selecionarAcrescimoPassagemCalculado from '../../actions/acrescimo-passagem/selecionarAcrescimoPassagemCalculado';
import calcularAcrescimoPassagem from '../../actions/acrescimo-passagem/calcularAcrescimoPassagem';
import recuperarFormaPagamentosDesativados from '../../actions/forma-pagamento/recuperarFormaPagamentosDesativados';

export class AbaFormaPagamento extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mensagem: { tipo: '', texto: '' },
      cartao: false,
      dinheiro: false,
      arquivo: null,
      valorTotalReserva: 0,
      habilitadoDescontoUsuarioIda: true,
      habilitadoAcrescimoPassagemIda: true,
      habilitadoDescontoUsuarioVolta: true,
      habilitadoAcrescimoPassagemVolta: true
    };
  }

  componentDidMount() {   
    const valorTotal = this.props.calcularValorTotal();
    this.setState({ valorTotalReserva: valorTotal })

    if (!this.props.formasPagamento || this.props.formasPagamento.length == 0) {
      // Se for vendedor agência, sempre configura dinheiro como forma de pagamento
      if (this.props.ehPerfilVendedorAgencia) {
        this.definirChecboxDinheiroComoOpcaoIncial(valorTotal);
        this.props.changeFieldValue('formReserva', 'pagamentoTEF', false);
        this.props.changeFieldValue('formReserva', 'cartaoCredito', false);
        this.props.changeFieldValue('formReserva', 'cartaoDebito', false);
        this.props.changeFieldValue('formReserva', 'pix', false);
        this.props.adicionarFormasPagamento([{
          tipo: 'Dinheiro',
          codigoTipo: 'DINHEIRO',
          base64Comprovante: '',
          numeroComprovante: '',
          valor: valorTotal,
          quantidadeParcelas: 1,
          descontoIda: null,
          descontoVolta: null,
          acrescimoPassagemIda: null,
          acrescimoPassagemVolta: null,
        }]);
      } else {
        this.definirChecboxDinheiroComoOpcaoIncial(valorTotal);

        if(this.props.pagamentoTEF === 'true') {
          this.props.adicionarFormasPagamento([{
                          tipo: 'pagamentoTEF',
                          base64Comprovante: '',
                          numeroComprovante: '',
                          valor: valorTotal,
                          quantidadeParcelas: 1,
                          descontoIda: null,
                          descontoVolta: null
                        }]);
        }else{
          this.props.changeFieldValue('formReserva', 'pagamentoTEF', false);
          this.props.adicionarFormasPagamento([{
                  tipo: 'Dinheiro',
                  base64Comprovante: '',
                  numeroComprovante: '',
                  valor: valorTotal,
                  quantidadeParcelas: 1,
                  descontoIda: null,
                  descontoVolta: null
                }]);
        }
      }
    }
    else {
      this.preencherDadosFormaPagamento();
      if (this.props.reservasSelecionadasRemarcacao && this.props.reservasSelecionadasRemarcacao.length > 0) {
        this.props.changeFieldValue('formReserva', 'valorDinheiro',
          valorTotal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));
      }
    }
  }

  definirChecboxDinheiroComoOpcaoIncial(valorTotalReserva) {
    const dinheiroDesativado = (this.props.pagamentosDesativados || []).includes('DINHEIRO')
      || (this.props.pagamentosDesativadosUsuario || []).includes('DINHEIRO');
    if (dinheiroDesativado) {
      return;
    }
    this.props.changeFieldValue('formReserva', 'dinheiro', true);
    this.props.changeFieldValue('formReserva',
      'valorDinheiro', valorTotalReserva.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));
  }

  alterarAba(aba) {
    this.setState({ tabAtiva: aba })
  }

  ativarAba(aba) {
    if (aba === this.state.tabAtiva) {
      return 'nav-link active'
    }
    return 'nav-link'
  }

  limparMensagem() {
    this.setState({ mensagem: undefined })
  }


  ehTipoEmissaoNormal(tipo) {
    return tipo === 'NORMAL'
  }

  habilitaOuDesabilitaDescontoUsuarioIda(valor) {
    this.setState({ habilitadoDescontoUsuarioIda: valor });
  }

  habilitaOuDesabilitaAcrescimoPassagemIda(valor) {
    this.setState({ habilitadoAcrescimoPassagemIda: valor });
  }

  habilitaOuDesabilitaDescontoUsuarioVolta(valor) {
    this.setState({ habilitadoDescontoUsuarioVolta: valor });
  }

  habilitaOuDesabilitaAcrescimoPassagemVolta(valor) {
    this.setState({ habilitadoAcrescimoPassagemVolta: valor });
  }

  permiteAcrescimoMaxmoUsuarioIda() {
    let normal = 0
    normal = this.props.passageirosIda.filter(passageiro => this.ehTipoEmissaoNormal(passageiro.tipoEmissao)).length
    return normal > 0 && this.props.viagemIda.acrescimoMaximoPassagem !== null
  }

  permiteAcrescimoMaximoUsuarioVolta() {
    let normal = 0
    normal += this.props.passageirosVolta.filter(passageiro => this.ehTipoEmissaoNormal(passageiro.tipoEmissao)).length
    return normal > 0 && this.props.viagemVolta.acrescimoMaximoPassagem !== null
  }

  permiteDescontoUsuarioRotaIda() {
    let normal = 0
    normal = this.props.passageirosIda.filter(passageiro => this.ehTipoEmissaoNormal(passageiro.tipoEmissao)).length
    return normal > 0 && this.props.viagemIda.descontoMaximoUsuarioRota !== null
  }

  permiteDescontoUsuarioRotaVolta() {
    let normal = 0
    normal += this.props.passageirosVolta.filter(passageiro => this.ehTipoEmissaoNormal(passageiro.tipoEmissao)).length
    return normal > 0 && this.props.viagemVolta.descontoMaximoUsuarioRota !== null
  }

  calcularDescontoUsuarioRotaIda(desconto) {
    if (this.permiteDescontoUsuarioRotaIda()) {
      let valorTotalIda = 0.00
      this.props.passageirosIda.forEach(passageiro => {
        if (this.ehTipoEmissaoNormal(passageiro.tipoEmissao)) {
          valorTotalIda += Number(passageiro.valor)
        }
      })
      const descontoMaximoUsuarioRota = Number(this.props.viagemIda.descontoMaximoUsuarioRota)
      const descontoInformado = Number(desconto)
      if (descontoMaximoUsuarioRota >= descontoInformado) {
        this.calcularDescontoUsuario(valorTotalIda, descontoInformado, 'IDA')
      }
    }
  }

  calcularDescontoUsuarioRotaVolta(desconto) {
    if (this.permiteDescontoUsuarioRotaVolta()) {
      let valorTotalVolta = 0.00
      this.props.passageirosVolta.forEach(passageiro => {
        if (this.ehTipoEmissaoNormal(passageiro.tipoEmissao)) {
          valorTotalVolta += Number(passageiro.valor)
        }
      })
      const descontoMaximoUsuarioRota = Number(this.props.viagemVolta.descontoMaximoUsuarioRota)
      const descontoInformado = Number(desconto)
      if (descontoMaximoUsuarioRota >= descontoInformado) {
        this.calcularDescontoUsuario(valorTotalVolta, descontoInformado)

      }
    }
  }

  calcularDescontoUsuario(valorTotal, descontoInformado, sentido) {
    this.props.calcularDescontoUsuario(valorTotal, descontoInformado)
      .then(resp => {
        if (resp.payload.status == 200) {
          this.props.selecionarDescontoInformado(descontoInformado)
          if (sentido == 'IDA') {
            this.props.selecionarDescontoUsuario({ ida: resp.payload.data, volta: this.props.valorDescontoUsuarioCalculado.volta })
          } else {
            this.props.selecionarDescontoUsuario({ ida: this.props.valorDescontoUsuarioCalculado.ida, volta: resp.payload.data })
          }
          const valorReserva = this.props.calcularValorTotal()
          this.setState({ valorTotalReserva: valorReserva })
          this.props.changeFieldValue('formReserva',
            'valorDinheiro', valorReserva.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));

        }
      })
  }

  calcularAcrescimoPassagemUsuarioIda(acrescimo) {
    if (this.permiteAcrescimoMaxmoUsuarioIda()) {
      let valorTotalIda = 0.00
      this.props.passageirosIda.forEach(passageiro => {
        if (this.ehTipoEmissaoNormal(passageiro.tipoEmissao)) {
          valorTotalIda += Number(passageiro.valor)
        }
      })
      const acrescimoMaximoPassagem = Number(this.props.viagemIda.acrescimoMaximoPassagem)
      const acrescimoInformado = Number(acrescimo)
      if (acrescimoMaximoPassagem >= acrescimoInformado) {
        this.calcularAcrescimoPassagem(valorTotalIda, acrescimoInformado, 'IDA')
      }
    }
  }

  calcularAcrescimoPassagemUsuarioVolta(acrescimo) {
    if (this.permiteAcrescimoMaximoUsuarioVolta()) {
      let valorTotalVolta = 0.00
      this.props.passageirosVolta.forEach(passageiro => {
        if (this.ehTipoEmissaoNormal(passageiro.tipoEmissao)) {
          valorTotalVolta += Number(passageiro.valor)
        }
      })
      const acrescimoMaximoPassagem = Number(this.props.viagemVolta.acrescimoMaximoPassagem)
      const acrescimoInformado = Number(acrescimo)
      if (acrescimoMaximoPassagem >= acrescimoInformado) {
        this.calcularAcrescimoPassagem(valorTotalVolta, acrescimoInformado)

      }
    }
  }

  calcularAcrescimoPassagem(valorTotal, acrescimoInformado, sentido) {
    this.props.calcularAcrescimoPassagem(valorTotal, acrescimoInformado)
      .then(resp => {
        if (resp.payload.status == 200) {
          this.props.selecionarAcrescimoPassagemInformado(acrescimoInformado);
          if (sentido == 'IDA') {
            this.props.selecionarAcrescimoPassagemCalculado({ida: resp.payload.data, volta: this.props.valorAcrescimoPassagemCalculado.volta })
          } else {
            this.props.selecionarAcrescimoPassagemCalculado({ida:this.props.valorAcrescimoPassagemCalculado.ida, volta: resp.payload.data })
          }
          const valorReserva = this.props.calcularValorTotal()
          this.setState({ valorTotalReserva: valorReserva })
          this.props.changeFieldValue('formReserva',
            'valorDinheiro', valorReserva.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));
        }
      })
  }

  calcularValorTotal() {
    this.props.calcularValorTotal()
  }

  preencherDadosFormaPagamento() {
    if (this.props.formasPagamento) {
      this.props.formasPagamento.forEach((f) => {
        if (f.tipo === 'Cartão') {
          this.props.changeFieldValue('formReserva',
            'cartao', true);
          this.props.changeFieldValue('formReserva',
            'valorCartao', f.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));
          this.props.changeFieldValue('formReserva',
            'quantideadeParcelas', Number(f.quantideadeParcelas));
          this.props.changeFieldValue('formReserva',
            'numeroComprovante', f.numeroComprovante);
          this.props.changeFieldValue('formReserva',
            'base64Comprovante', f.base64Comprovante);
        }
        if (f.tipo === 'Dinheiro') {
          this.props.changeFieldValue('formReserva',
            'dinheiro', true);
          this.props.changeFieldValue('formReserva',
            'valorDinheiro', f.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));
        }
        if(f.tipo === 'PIX') {
          this.props.changeFieldValue('formReserva',
          'pix', true);
        this.props.changeFieldValue('formReserva',
          'valorPIX', f.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));
        this.props.changeFieldValue('formReserva',
          'numeroComprovantePIX', f.numeroComprovante);
        this.props.changeFieldValue('formReserva',
          'base64ComprovantePIX', f.base64Comprovante);
        }

        this.props.changeFieldValue('formReserva',
          'tipo', f.tipo);

        this.props.changeFieldValue('formReserva',
          'descontoIda', f.descontoIda);

        this.props.changeFieldValue('formReserva',
          'descontoVolta', f.descontoVolta);
      })
    }
  }
  
  handleHabilitadoZerarValorMultaRemarcacao(e) {
    const checked = e.target.checked;
    this.props.handleHabilitadoZerarValorMultaRemarcacao(e);

    const valorReserva = this.props.calcularValorTotal(checked);
    this.setState({ valorTotalReserva: valorReserva });
    this.props.changeFieldValue('formReserva',
      'valorDinheiro', valorReserva.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));
  }

  render() {
    return (
      <React.Fragment>
        <div className="vx-pay-summary">
          <div className="vx-pay-total-item">
            <span className="vx-pay-total-label">Valor total</span>
            <span className="vx-pay-total-value">
              {this.props.calcularValorTotalSemTarifaSeguro().toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
            </span>
          </div>
          <div className="vx-pay-total-item">
            <span className="vx-pay-total-label">Total com seguro</span>
            <span className="vx-pay-total-value">
              {this.state.valorTotalReserva.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
            </span>
          </div>
        </div>

        <FormCadastrarFormaPagamento totalReserva={this.state.valorTotalReserva}
          calcularDescontoUsuarioRotaIda={this.calcularDescontoUsuarioRotaIda.bind(this)}
          calcularDescontoUsuarioRotaVolta={this.calcularDescontoUsuarioRotaVolta.bind(this)}
          permiteDescontoUsuarioRotaIda={this.permiteDescontoUsuarioRotaIda.bind(this)}
          permiteDescontoUsuarioRotaVolta={this.permiteDescontoUsuarioRotaVolta.bind(this)}
          calcularAcrescimoPassagemUsuarioIda={this.calcularAcrescimoPassagemUsuarioIda.bind(this)}
          calcularAcrescimoPassagemUsuarioVolta={this.calcularAcrescimoPassagemUsuarioVolta.bind(this)}
          permiteAcrescimoMaximoUsuarioVolta={this.permiteAcrescimoMaximoUsuarioVolta.bind(this)}
          permiteAcrescimoMaxmoUsuarioIda={this.permiteAcrescimoMaxmoUsuarioIda.bind(this)}
          habilitaOuDesabilitaDescontoUsuarioIda={this.habilitaOuDesabilitaDescontoUsuarioIda.bind(this)}
          habilitaOuDesabilitaAcrescimoPassagemIda={this.habilitaOuDesabilitaAcrescimoPassagemIda.bind(this)}
          habilitaOuDesabilitaDescontoUsuarioVolta={this.habilitaOuDesabilitaDescontoUsuarioVolta.bind(this)}
          habilitaOuDesabilitaAcrescimoPassagemVolta={this.habilitaOuDesabilitaAcrescimoPassagemVolta.bind(this)}
          habilitadoDescontoUsuarioIda={this.state.habilitadoDescontoUsuarioIda}
          habilitadoAcrescimoPassagemIda={this.state.habilitadoAcrescimoPassagemIda}
          habilitadoDescontoUsuarioVolta={this.state.habilitadoDescontoUsuarioVolta}
          habilitadoAcrescimoPassagemVolta={this.state.habilitadoAcrescimoPassagemVolta}
          ehRemarcacao={this.props.reservasSelecionadasRemarcacao && this.props.reservasSelecionadasRemarcacao.length > 0}
          empresaSelecionada={this.props.empresaSelecionada}
          verificarSeFormaPagamentoNaoFoiSelecionado={this.props.verificarSeFormaPagamentoNaoFoiSelecionado}
          handleHabilitadoZerarValorMultaRemarcacao={this.handleHabilitadoZerarValorMultaRemarcacao.bind(this)}
          ehPerfilVendedorAgencia={this.props.ehPerfilVendedorAgencia}
        />
      </React.Fragment>
    )
  }
}
export function mapStateToProps(state) {
  return {
    formasPagamento: state.formasPagamento,
    empresaSelecionada: state.empresaSelecionada,
    usuariosEmpresa: state.usuariosEmpresa,
    viagemIda: state.viagemIda,
    viagemVolta: state.viagemVolta,
    passageirosIda: state.passageirosIda,
    passageirosVolta: state.passageirosVolta,
    valorDescontoUsuarioCalculado: state.valorDescontoUsuarioCalculado,
    reservasSelecionadasRemarcacao: state.remarcacao.reservasSelecionadas,
    valorAcrescimoPassagemCalculado: state.valorAcrescimoPassagemCalculado,
    pagamentosDesativados: state.pagamentosDesativados.pagamentosDesativados,
    pagamentosDesativadosUsuario: state.pagamentosDesativadosUsuario.pagamentosDesativadosUsuario,

  }
}


export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    adicionarFormasPagamento,
    calcularDescontoUsuario,
    selecionarDescontoUsuario,
    selecionarAcrescimoPassagemCalculado,
    calcularAcrescimoPassagem,
    recuperarFormaPagamentosDesativados
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formReserva',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(AbaFormaPagamento));
